<template>
 <!-- :class="footstyle>=9?'':''" -->
  <Footer class="layout-footer-center textcenter">
    <div class="tab-link">
      <router-link :to="{path:'/'}">首页</router-link>
      <router-link :to="{path:'/train/index'}">线下课程</router-link>
      <router-link :to="{path:'/online/index'}">在线课程</router-link>
      <router-link :to="{path:'/mall/index'}">商城</router-link>
      <!-- <router-link :to="{path:'/about/index'}">关于我们</router-link> -->
    </div>
    <p style="color:white;">
      版权所有@邱显峰整体瑜伽&nbsp;&nbsp;&nbsp;
      <a
        style="color:white;"
        target="_blank"
        href="http://beian.miit.gov.cn/"
      >备案号：辽ICP备19010043号-1</a>
    </p>
    <!-- <div>版权所有@邱显峰整体瑜伽  备案号：辽ICP备19010043号-1</div> -->
  </Footer>
</template>

<script>
export default {
  props: ["parentToChild"],
  data() {
    return {
		footstyle:""
	};
  },
  created() {
	// console.info("--->", this.parentToChild);
	// this.footstyle = this.parentToChild.length;
  }
};
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/FooterDes.vue